import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex py-1" }
const _hoisted_2 = { class: "max-w-60 overflow-ellipsis" }

import { computed, getCurrentInstance } from 'vue';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import { getCardStatus } from '@/utilities/defaultCardStatuses';
import cardStatusType from '@/types/cardStatusType';
import { ResourceType } from '@/types/resources';


export default /*@__PURE__*/_defineComponent({
  __name: 'CardStatusAndTitle',
  props: {
  title: {
    type: String,
    required: true,
  },
  cardId: {
    type: String,
    required: true,
  },
  status: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const { iconPath, getCustomIconStyle } = useCustomIcon();
const _this = getCurrentInstance()!.proxy as any;

const props = __props;

const stateCard = computed(() => _this.$store.getters.getCards[props.cardId] || {});

const icon = computed(() => {
  const isEpic = stateCard.value?.type === ResourceType.Epic;
  return getCustomIconStyle(
    iconPath(
      getCardStatus(stateCard.value?.status || props.status, isEpic)?.icon ||
        getCardStatus(cardStatusType.Backlog, isEpic).icon
    )
  );
});

const backgroundColor = computed(() => {
  return (
    stateCard.value?.list_color ||
    stateCard.value?.color ||
    getCardStatus(props.status)?.color ||
    getCardStatus(cardStatusType.Backlog).color
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("em", {
      class: "custom-icons w-4 h-4 mr-0.5",
      style: _normalizeStyle({
        ...icon.value,
        backgroundColor: backgroundColor.value,
      })
    }, null, 4),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("span", _hoisted_2, _toDisplayString(stateCard.value?.title || __props.title), 1)
  ]))
}
}

})